import { SymmetricVerticalBarChartProps } from '@components/report/chart/symmetric-vertical-bar-chart/SymmetricVerticalBarChart';

const bannerHashtags = {
	empty: new Array(5).fill('-'),
	example: new Array(5).fill('example'),
};

const postMetrics = {
	empty: '-',
	examples: '?',
};

const categories: Record<string, SymmetricVerticalBarChartProps> = {
	empty: {
		topData: new Array(4).fill({
			value: '?%',
			valuePercentage: 0,
		}),
		categories: new Array(4).fill('??'),
	},
	example: {
		topData: new Array(4).fill({
			value: '?%',
			valuePercentage: 0,
		}),
		categories: new Array(4).fill('example'),
	},
};

const fallbacks = {
	bannerHashtags,
	postMetrics,
	categories,
};

export default fallbacks;
